import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZzz = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 10.3364V12H16.5028H15.5996H15V10.7357L19.0222 5.67098H15.1246V4H20.3493H21.0812H21.8754V5.22736L17.8225 10.3364H22ZM13.2676 15.0215V16.3398H9.13086H8.45117H8V15.3379L11.0268 11.3242H8.09375V10H12.0254H12.5762H13.1738V10.9727L10.1239 15.0215H13.2676ZM6 19.3398V18.3001H3.61285L5.92881 15.1069V14.3398H5.47497H5.05673H2.07119V15.3842H4.29842L2 18.5496V19.3398H2.3426H2.85873H6Z"
	})
});
export default SvgZzz;
